import { create } from 'zustand';
import axios from 'axios';
import { vpApi } from '../api/velopulse';

const ORG_KEY = 'vp_current_org';
const RECENT_KEY = 'vp_recent_orgs';

// 目前組織一律透過 X-Org-Id 標頭送給後端（後端仍須自行驗證成員資格）
const setOrgHeader = (org) => {
  if (org?.id) axios.defaults.headers.common['X-Org-Id'] = org.id;
  else delete axios.defaults.headers.common['X-Org-Id'];
};

const readJson = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

const storedOrg = readJson(ORG_KEY, null);
setOrgHeader(storedOrg);

export const useOrgStore = create((set, get) => ({
  currentOrg: storedOrg,
  orgs: null, // null＝尚未載入
  orgsError: null,
  entering: null, // 正在進入的組織（顯示全屏 loading）

  fetchOrgs: async () => {
    try {
      const orgs = await vpApi.listOrgs();
      const { currentOrg } = get();
      // 已存的組織不在此帳號的清單內（換帳號／被移除）→ 清掉，避免錯租戶
      if (currentOrg && !orgs.some((o) => o.id === currentOrg.id)) {
        get().clearOrg();
      } else if (currentOrg) {
        const fresh = orgs.find((o) => o.id === currentOrg.id);
        if (fresh && (
          fresh.org_role !== currentOrg.org_role
          || fresh.role !== currentOrg.role
          || JSON.stringify(fresh.modules || []) !== JSON.stringify(currentOrg.modules || [])
        )) {
          localStorage.setItem(ORG_KEY, JSON.stringify(fresh));
          set({ currentOrg: fresh });
        }
      }
      set({ orgs, orgsError: null });
      return orgs;
    } catch (err) {
      set({ orgs: [], orgsError: err });
      return [];
    }
  },

  recentIds: () => readJson(RECENT_KEY, []),

  // 硬切換：寫入後整頁重新載入，確保所有頁面資料完整更換、不殘留上一個組織的狀態
  enterOrg: (org, to = '/') => {
    const recent = [org.id, ...readJson(RECENT_KEY, []).filter((id) => id !== org.id)].slice(0, 5);
    localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
    localStorage.setItem(ORG_KEY, JSON.stringify(org));
    setOrgHeader(org);
    set({ entering: org });
    setTimeout(() => window.location.assign(to), 700);
  },

  updateCurrentOrg: (patch) => {
    const current = get().currentOrg;
    if (!current) return;
    const next = { ...current, ...patch };
    localStorage.setItem(ORG_KEY, JSON.stringify(next));
    setOrgHeader(next);
    set({
      currentOrg: next,
      orgs: (get().orgs || []).map((o) => (o.id === next.id ? { ...o, ...patch } : o)),
    });
  },

  clearOrg: () => {
    localStorage.removeItem(ORG_KEY);
    setOrgHeader(null);
    set({ currentOrg: null });
  },
}));
